import React from "react";
import { Link, useLocation } from "react-router-dom";
import { tw } from "@careinfo/tailwind";

const SwitchTab = ({ tabs }) => {
  const location = useLocation();

  return (
    <div className={tw`flex gap-x-4 mb-2`}>
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.href;
        return (
          <Link
            to={tab.href}
            key={tab.id}
            className={tw`
              font-bold text-xl flex items-center gap-x-2  focus:outline-none
              ${isActive ? "border-primary border-b-2 " : "text-gray-500"}
            `}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
};

export default SwitchTab;
